document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sh-mobile-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = button.closest('.sh-mobile-menu');
      if (!menu) return;
      menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sh-mobile-menu.is-open').forEach((menu) => {
      if (!menu.contains(event.target)) {
        menu.classList.remove('is-open');
        const button = menu.querySelector('[data-sh-mobile-toggle]');
        if (button) button.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

// Premium policy-page typography. Scoped strictly to Shopify policy pages.
document.addEventListener('DOMContentLoaded', () => {
  const policy = document.querySelector('.shopify-policy__container');
  if (!policy) return;

  const title = policy.querySelector('.shopify-policy__title h1');
  const body = policy.querySelector('.shopify-policy__body');
  if (!body) return;

  const normalize = (value) => value
    .toUpperCase()
    .replace(/&/g, ' AND ')
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim();

  const pageTitle = title ? normalize(title.textContent) : '';

  body.querySelectorAll('p').forEach((paragraph, index) => {
    const text = paragraph.textContent.trim().replace(/\s+/g, ' ');
    if (!text) return;

    const letters = text.replace(/[^A-Za-z]/g, '');
    const isShortAllCapsHeading =
      letters.length >= 3 &&
      text.length <= 75 &&
      text === text.toUpperCase();

    if (!isShortAllCapsHeading) return;

    if (index <= 3 && pageTitle && normalize(text) === pageTitle) {
      paragraph.classList.add('sh-policy-duplicate-title');
      return;
    }

    paragraph.classList.add('sh-policy-heading');
  });
});

